<div class="content">
  <app-auto-lots-filter></app-auto-lots-filter>
  <nz-divider></nz-divider>

  <nz-row nzJustify="center" class="purchase-statistics">
    <app-user-purchase-statistics></app-user-purchase-statistics>
  </nz-row>

  <nz-table
    #table
    class="table"
    nzTitle="{{ 'TOTAL' | translate }}: {{ (total$ | async) || 0 }}"
    [nzData]="(lots$ | async) || []"
    [nzTotal]="(total$ | async) || 0"
    [nzLoading]="(loading$ | async) || false"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzFrontPagination]="false"
    [nzBordered]="true"
    [nzPaginationPosition]="'both'"
    [nzSize]="'small'"
    (nzPageIndexChange)="changePage($event)"
    (nzPageSizeChange)="changePageSize($event)"
    nzShowSizeChanger
    nzOuterBordered
  >
    <thead>
    <tr>
      <th rowspan="2" nzAlign="center">{{ 'PHOTO' | translate }}</th>
      <th rowspan="2" nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'bid'"
          [title]="'LOT' | translate"
        ></app-sort-component>
      </th>
      <th rowspan="1" nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'auctRef'"
          [title]="'LOT_INFO.AUCTION' | translate"
        ></app-sort-component>
      </th>
      <th rowspan="1" nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'modelYearEn'"
          [title]="'LOT_INFO.YEAR' | translate"
        ></app-sort-component>
      </th>
      <th rowspan="1" nzAlign="center" [ngClass]="'hide-column-small hide-column-medium'">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'displacementNum'"
          [title]="'LOT_INFO.ENGINE_CC' | translate"
        ></app-sort-component>
      </th>
      <th rowspan="1" nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'mileageNum'"
          [title]="'LOT_INFO.MILEAGE' | translate"
        ></app-sort-component>
      </th>
      <th rowspan="1" nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'startPriceNum'"
          [title]="'LOT_INFO.START_PRICE' | translate"
        ></app-sort-component>
      </th>
    </tr>
    <tr>
      <th nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'date'"
          [title]="'DATE' | translate"
        ></app-sort-component>
      </th>
      <th nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'modelTypeEn'"
          [title]="'FRAME_MODEL' | translate"
        ></app-sort-component>
      </th>
      <th nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'colorEn'"
          [title]="'LOT_INFO.COLOR' | translate"
        ></app-sort-component>
      </th>
      <th nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'scoresEn'"
          [title]="'LOT_INFO.SCORE' | translate"
        ></app-sort-component>
      </th>
      <th nzAlign="center">
        <app-sort-component
          (nzSortChange)="sortEvent($event)"
          [sortKey]="'endPriceNum'"
          [title]="'LOT_INFO.SOLD_FOR' | translate"
        ></app-sort-component>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of table.data">
      <td nzAlign="center">
        <app-lot-mini-gallery [lot]="item"></app-lot-mini-gallery>
      </td>
      <td nzAlign="center">
        <ng-container *ngIf="lotListData$ | async as lotListData">
          <app-lots-list-lot-link
            [lot]="item"
            [lotType]="LotTypeEnum.Auto"
            [lotSource]="LotSource.Aleado"
            link="/auto/lot/{{ item.id }}"
            [lotData]="lotListData.get(item.id)"
          ></app-lots-list-lot-link>
        </ng-container>

        <ng-container *ngIf="lotInspectedData$ | async as lotInspectedData">
          <nz-tag
            *ngIf="lotInspectedData.get(item.id)"
            nzColor="success"
            nz-tooltip
            [nzTooltipTitle]="'LOT_INSPECTION_AVAILABLE_TOOLTIP' | translate"
          >
            {{ 'LOT_INSPECTION_AVAILABLE' | translate }}
          </nz-tag>
        </ng-container>

        <ng-container *ngIf="lotWatchRequestAvailableData$ | async as lotWatchRequestAvailableData">
          <nz-tag
            *ngIf="lotWatchRequestAvailableData.get(item.id)"
            nzColor="processing"
          >
            {{ 'WATCH_REQUEST.TITLE' | translate }}
          </nz-tag>
        </ng-container>
      </td>
      <td nzAlign="center">
        <app-lot-auction-name [auctionName]="item.autoAuction?.name"></app-lot-auction-name>
        <br />
        {{ item.time | date: 'yyyy-MM-dd H:mm:ss zz':'+0900' }}
      </td>
      <td nzAlign="left" [ngClass]="'hide-column-small hide-column-medium'">
        <a
          class="blue-light-text"
          [routerLink]="['/auto']"
          [queryParams]="{ company: item.companyRef, model: item.modelNameRef, page: 1 }"
        >
          {{ item.companyEn }} {{ item.modelNameEn }}
        </a>
        <br />
        <span nz-text nzType="danger">{{ item.year }}</span>
        <span>{{ normalizeFrame(item.frame) }}</span>
        <br />
        <span nz-text [innerHTML]="item.modelGrade" nzType="secondary"></span>
      </td>
      <td nzAlign="left">
        <span nz-text nzType="danger">{{ item.transmissionEn }}</span>
        {{ item.engineVolume }} cc<br />
        <span nz-text nzType="secondary">{{ item.colorEn }}</span>
      </td>
      <td nzAlign="right">
        {{ item.mileage }}{{ item.mileage > 0 ? '000' : '' }} km
        <span nz-text nzType="warning" style="display: inline-block; min-width: 2em">
            {{ item.rate }}
          </span>
      </td>
      <td>
        <nz-row nzJustify="end">
          <div>
            {{ item.startPrice | currency: 'JPY':'symbol-narrow' }}
            <br />
            <ng-container *ngIf="lotListData$ | async as lotListData">
              {{
                lotListData.get(item.id)?.soldPrice || item.finishPrice
                  | currency: 'JPY':'symbol-narrow'
              }}
            </ng-container>
            <nz-tag *ngIf="item.result" class="m-0">
              {{ item.result | translate }}
            </nz-tag>
          </div>
          <app-lot-place-bid-button-dumb
            [lot]="item"
            [lotType]="LotTypeEnum.Auto"
            [lotSource]="LotSource.Aleado"
          ></app-lot-place-bid-button-dumb>
        </nz-row>
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>
